import { CustomerInfoService } from './../../../../services/customer/customerinfo.service';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-family-card',
  templateUrl: './family-card.component.html',
  styleUrls: ['./family-card.component.css']
})
export class FamilyCardComponent implements OnInit {

  isParent = false;
  showParentSelectionField = true;
  parent: {label: string, value: number};
  availableParents: {label: string, value: number}[] = [];
  invalidParent = false;
  linkedCustomers: any[];
  customerId: string;

  @Input() customerHostId: string;

  constructor(private customerInfoService: CustomerInfoService) { }

  ngOnInit() {
    this.customerInfoService.getVCustomerByHost(this.customerHostId).subscribe(
      res => this.customerId = res.id.toString(),
      err => console.error(err),
      () => this.getLinkedCustomers()
    )
  }

  getFilteredAvailableParents(event) {
    this.customerInfoService.getAvailableParents(event.query).subscribe(res => this.availableParents = res);
  }

  linkCustomerToParent() {
    if (!this.parent.value) {
      this.invalidParent = true;
      return;
    }
    this.customerInfoService.linkCustomerToParent(this.customerId, this.parent.value.toString()).subscribe(
      () => {
        if (this.invalidParent) {
          this.invalidParent = false;
        }
        this.getLinkedCustomers();
      },
      err => this.invalidParent = true
    );
  }

  getLinkedCustomers() {
    this.customerInfoService.getLinkedCustomers(this.customerId).subscribe(customers => {
      this.linkedCustomers = customers.length > 0 ? customers : [];
      if (customers.length > 0) {
        this.linkedCustomers = customers;
        this.showParentSelectionField = false;
        customers.forEach(customer => {
          if (customer.parentId) {
            this.isParent = true;
            return;
          }
        })
      } else {
        this.linkedCustomers = [];
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customers/family-card/family-card.component.ts